export default __webpack_public_path__ + "static/media/Coastbusterssites2021.68d3c810.jpg";